const buildNormalizedRestaurantAddresses = (
  primaryAddress,
  additionalAddresses,
  defaultLabel = ''
) => {
  const addressesList = [];

  if (primaryAddress) {
    addressesList.push({
      address: primaryAddress,
      id: null,
      label: defaultLabel
    });
  }

  if (Array.isArray(additionalAddresses)) {
    additionalAddresses.forEach((address) => {
      if (address?.address) {
        addressesList.push({
          address: address.address,
          id: address.entityId || address.id || null,
          label: (address.label || address.name || '').trim()
        });
      }
    });
  }

  return addressesList;
};

const getFormAddressesFromRestaurant = restaurantAddresses => (
  Array.isArray(restaurantAddresses) ?
    restaurantAddresses.map(address => ({
      address: address?.address || '',
      entityId: address?.entityId || address?.id || null,
      label: (address?.label || address?.name || '').trim()
    })) :
    []
);

const googleMapsSearchParamAddress = address => address.replaceAll(' ', '+');

const normalizeAddressesForComparison = addresses => (
  Array.isArray(addresses) ?
    addresses.map(address => ({
      address: (address?.address || '').trim(),
      entityId: address?.entityId || address?.id || null,
      label: (address?.label || address?.name || '').trim()
    })) :
    []
);

export {
  buildNormalizedRestaurantAddresses,
  getFormAddressesFromRestaurant,
  googleMapsSearchParamAddress,
  normalizeAddressesForComparison
};
